import React from "react";
import { Link } from "react-router-dom";
import { ContactEmail, PolicyPage, PolicySection } from "./PolicyPage";

function CookiePolicy() {
  return (
    <PolicyPage
      title="Cookie Policy"
      intro="This policy explains how Sacuddin uses cookies, browser storage, pixels, and similar technologies on sacuddin.shop."
    >
      <PolicySection title="1. What these technologies are">
        <p>
          Cookies are small files placed on a browser or device. Local storage saves
          information in the browser, while pixels and similar tags can record that a
          page or message was viewed. First-party technologies are set for Sacuddin;
          third-party technologies are provided by another service.
        </p>
      </PolicySection>

      <PolicySection title="2. Categories we may use">
        <ul>
          <li><strong>Strictly necessary:</strong> operate core pages, remember cart contents, support checkout, prevent fraud, balance traffic, and record privacy choices. These cannot generally be switched off through our site.</li>
          <li><strong>Functional:</strong> remember language, region, display, and other choices to provide requested features.</li>
          <li><strong>Analytics:</strong> help us understand visits, navigation, errors, and aggregate performance so we can improve the store.</li>
          <li><strong>Advertising:</strong> measure campaigns, limit repetition, and, where permitted, help present relevant promotions on or off our site.</li>
        </ul>
        <p>
          The technologies actually available can change as site providers change. We
          use optional categories only with consent where the law requires it.
        </p>
      </PolicySection>

      <PolicySection title="3. Duration">
        <p>
          Session cookies expire when the browser closes. Persistent cookies remain for
          a set period or until deleted. Duration depends on purpose: cart and preference
          storage may last long enough to remember a return visit, while security and
          consent records may be retained longer to document choices and protect the
          service. Third-party providers set their own durations.
        </p>
      </PolicySection>

      <PolicySection title="4. Your controls">
        <p>
          Where a cookie control is displayed, use it to accept, reject, or revise
          optional categories. You can also block or delete cookies using browser
          settings. Blocking necessary storage may cause the cart, checkout, sign-in,
          or security features to stop working correctly. Browser-based opt-out signals
          are honored where required and technically detectable.
        </p>
        <p>
          Advertising choices are usually browser- and device-specific. Clearing
          storage or changing devices may reset them. See <Link to="/privacy-choices">Privacy Choices</Link> for additional request options.
        </p>
      </PolicySection>

      <PolicySection title="5. Third parties and privacy">
        <p>
          Commerce, payment, delivery, security, analytics, customer-support, and
          advertising providers may use these technologies when supplying services.
          Their own notices explain processing they control. For more information about
          our handling of personal information, read the <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </PolicySection>

      <PolicySection title="6. Updates and contact">
        <p>
          We may update this policy when technologies or legal requirements change.
          Questions and requests may be sent to <ContactEmail subject="Cookie policy question" />.
        </p>
      </PolicySection>
    </PolicyPage>
  );
}

export default CookiePolicy;

